import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const OppSourceChannelFilterComponent = ({
  value,
  onChange,
  options,
  classes,
  paddingAvailable = false,
}) => {
  //   const classes = useStyles();

  return (
    <Grid item xs={12} container component={Paper} spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        style={paddingAvailable ? {} : { paddingTop: 0 }}
      >
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel
            className={classes.filterLabel}
            style={{ color: !value.includes("All") ? "#4472c4" : "#000" }}
            id="select-oppsourcechannel-label"
          >
            Opp. Source Channel :
          </InputLabel>
          <Select
            data-test="Opportunity_Source_Channel__c"
            value={value}
            onChange={onChange}
            name="Opportunity_Source_Channel__c"
            multiple
          >
            <MenuItem value={"All"}>All</MenuItem>
            {options &&
              options.map((item) => (
                <MenuItem
                  key={item.Opportunity_Source_Channel__c}
                  value={item.Opportunity_Source_Channel__c}
                >
                  {item.Opportunity_Source_Channel__c}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default OppSourceChannelFilterComponent;
